import { render } from "./RecentObjectsList.vue?vue&type=template&id=74713614"
import script from "./RecentObjectsList.vue?vue&type=script&lang=js"
export * from "./RecentObjectsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__